import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IDetalleProducto } from '../interfaces/';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})

export class CartService {

  private cart = new BehaviorSubject<Array<IDetalleProducto>>(null);
  public currentDataCart$ = this.cart.asObservable();

  constructor( private storageService: StorageService ) { }

  public changeCart( newData: IDetalleProducto ) {
    // Obtenemos el valor actual
    let listCart = this.cart.getValue();

    // Si no es el primer item del carrito
    if (listCart) {
      // Buscamos si ya cargamos ese item en el carrito
      const objIndex = listCart.findIndex((obj => obj.id === newData.id));

      // Si ya cargamos uno aumentamos su cantidad
      if (objIndex !== -1) {
        listCart[objIndex].cantidad += newData.cantidad;
      } else { // Si es el primer item de ese tipo lo agregamos derecho al carrito
        listCart.push(newData);
      }
    } else { // Si es el primer elemento lo inicializamos
      listCart = [];
      listCart.push(newData);
    }
    // Enviamos el valor a todos los Observers que estan escuchando nuestro Observable
    this.cart.next(listCart);
    this.storageService.set('carrito', listCart);
  }

  public replaceCantidad( newData: IDetalleProducto ) {
    // Obtenemos el valor actual
    let listCart = this.cart.getValue();

    // Si no es el primer item del carrito
    if (listCart) {
      // Buscamos si ya cargamos ese item en el carrito
      const objIndex = listCart.findIndex((obj => obj.id === newData.id));
      // Si ya cargamos uno aumentamos su cantidad
      if (objIndex !== -1) {
        listCart[objIndex].cantidad = newData.cantidad;
      } else { // Si es el primer item de ese tipo lo agregamos derecho al carrito
        listCart.push(newData);
      }
    }
    // Si es el primer elemento lo inicializamos
    else {
      listCart = [];
      listCart.push(newData);
    }
    // Enviamos el valor a todos los Observers que estan escuchando nuestro Observable
    this.cart.next(listCart);
    this.storageService.set('carrito', listCart);
  }

  public removeElementCart(newData: IDetalleProducto) {
    try {
      // Obtenemos el valor actual de carrito
      const listCart = this.cart.getValue();
      if ( listCart.length > 0 ) {
        // Buscamos el item del carrito para eliminar
        const objIndex = listCart.findIndex((obj => obj.id === newData.id));
        if (objIndex !== -1) {
          // Seteamos la cantidad en 1
          // (ya que los array se modifican los valores por referencia, si vovlemos a agregarlo la cantidad no se reiniciará)
          listCart[objIndex].cantidad = 1;

          // Eliminamos el item del array del carrito
          listCart.splice(objIndex, 1);
        }
        this.cart.next(listCart); // Enviamos el valor a todos los Observers que estan escuchando nuestro Observable
        this.storageService.set('carrito', listCart);
      }
    } catch (err) {
      console.log(err);
    }
  }

  public removeAllElementCart( data: IDetalleProducto[] ) {
    for (const item of data) {
      this.removeElementCart( item );
    }
  }

  public resetCart() {
    const listCart = [];
    this.cart.next(listCart);
  }

  /**
   * A-486: Reemplaza el carrito completo y lo persiste en Storage.
   * Usado por CartPage al rehidratar para limpiar productos descatalogados sin
   * disparar la logica acumulativa de `changeCart`.
   */
  public setCart( newCart: IDetalleProducto[] ) {
    const list = Array.isArray(newCart) ? newCart : [];
    this.cart.next(list);
    this.storageService.set('carrito', list);
  }
}
